import { jsx } from '@theme-ui/core';
import { css, get } from '@theme-ui/css';
import { useMemo } from 'react';
import { useMDXComponents, MDXProvider as MDXProvider$1 } from '@mdx-js/react';

/** @jsx jsx */
// mdx components
const tags = ['p', 'b', 'i', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'pre', 'code', 'ol', 'ul', 'li', 'blockquote', 'hr', 'em', 'table', 'tr', 'th', 'td', 'em', 'strong', 'del', // mdx
'inlineCode', 'thematicBreak', // other
'div', // theme-ui
'root'];
const aliases = {
  inlineCode: 'code',
  thematicBreak: 'hr',
  root: 'div'
};

const isAlias = x => x in aliases;

const alias = n => isAlias(n) ? aliases[n] : n;

const themed = key => ({
  theme,
  ...rest
}) => {
  const extraStyles = {};

  if (key === 'th' || key === 'td') {
    const {
      align
    } = rest;
    if (align !== 'char') extraStyles.textAlign = align;
  }

  return css({ ...get(theme, `styles.${key}`),
    ...extraStyles
  })(theme);
}; // opt out of typechecking whenever `as` prop is used

const createThemedComponent = (name, variant) => {
  const variantStyles = themed(variant);
  return props => {
    const css = props['css'];
    return jsx(name, { ...props,
      css: css ? [css, variantStyles] : variantStyles
    });
  };
};

const _Themed = createThemedComponent('div', 'div');

const components = {};
const Themed = _Themed;
tags.forEach(tag => {
  const component = createThemedComponent(alias(tag), tag);
  components[tag] = component;
  Themed[tag] = component;
});

const createComponents = comps => {
  const componentKeys = Object.keys(comps);
  const next = { ...components
  }; // We enrich user's components with the styles from theme.styles.
  // Example: `components.p` will get the styles from `theme.styles.p` as className.
  // todo: test this behaviour

  componentKeys.forEach(key => {
    const componentAtKey = comps[key];

    if (componentAtKey) {
      next[key] = props => jsx(componentAtKey, { ...props,
        css: themed(key)
      });
    }
  });
  return next;
};

const MDXProvider = ({
  components,
  children
}) => {
  const outer = useMDXComponents();
  const themedComponents = useMemo(() => {
    return createComponents({ ...outer,
      ...components
    });
  }, [components, outer]);
  return jsx(MDXProvider$1, {
    components: themedComponents,
    children
  });
};

export { MDXProvider, Themed, components, themed };
